/**
 * Diagnosis Service
 * Patient diagnosis tracking and management API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AnnotationDto } from './annotationDto';


export interface UpdateDiagnosisRequestDto { 
    /**
     * Element identifier from reference data
     */
    elementId: string;
    /**
     * Status of the diagnosis
     */
    status?: UpdateDiagnosisRequestDto.StatusEnum;
    /**
     * Priority of the diagnosis
     */
    priority: UpdateDiagnosisRequestDto.PriorityEnum;
    /**
     * Clinical status of the diagnosis
     */
    clinicalStatus?: string;
    /**
     * Verification status of the diagnosis
     */
    verificationStatus?: string;
    /**
     * Severity of the diagnosis
     */
    severity?: string;
    /**
     * Body site element IDs
     */
    bodySite?: Array<string>;
    /**
     * Onset date and time
     */
    onsetDateTime?: string;
    /**
     * Abatement date and time
     */
    abatementDateTime?: string;
    /**
     * Date recorded
     */
    recordedDate?: string;
    /**
     * Recorder identifier
     */
    recorder?: string;
    /**
     * Asserter identifier
     */
    asserter?: string;
    /**
     * Stage of the diagnosis
     */
    stage?: string;
    /**
     * Prognosis
     */
    prognosis?: UpdateDiagnosisRequestDto.PrognosisEnum;
    /**
     * Clinical notes
     */
    note?: Array<AnnotationDto>;
    /**
     * Additional metadata
     */
    metadata?: any;
}
export namespace UpdateDiagnosisRequestDto {
    export type StatusEnum = 'preliminary' | 'confirmed' | 'differential' | 'ruled_out' | 'resolved';
    export const StatusEnum = {
        Preliminary: 'preliminary' as StatusEnum,
        Confirmed: 'confirmed' as StatusEnum,
        Differential: 'differential' as StatusEnum,
        RuledOut: 'ruled_out' as StatusEnum,
        Resolved: 'resolved' as StatusEnum
    };
    export type PriorityEnum = 'primary' | 'secondary' | 'tertiary';
    export const PriorityEnum = {
        Primary: 'primary' as PriorityEnum,
        Secondary: 'secondary' as PriorityEnum,
        Tertiary: 'tertiary' as PriorityEnum
    };
    export type PrognosisEnum = 'excellent' | 'good' | 'fair' | 'poor' | 'guarded';
    export const PrognosisEnum = {
        Excellent: 'excellent' as PrognosisEnum,
        Good: 'good' as PrognosisEnum,
        Fair: 'fair' as PrognosisEnum,
        Poor: 'poor' as PrognosisEnum,
        Guarded: 'guarded' as PrognosisEnum
    };
}


